// Props do `DataTable` cru para linha clicável; no `HubTable` use `onRowClick`, que aplica a mesma regra.
import type { DataTableRowClickEvent } from "primereact/datatable";

/** Classe global (styles/globals.css) que sinaliza a linha como clicável. */
export const CLICKABLE_ROW_CLASS = "hub-clickable-row";

/** Controles dentro da linha que mantêm a função própria e não acionam a linha. */
const INTERACTIVE_SELECTOR =
  "button, a, input, select, textarea, label, [role='button'], .p-checkbox, .p-button, .p-disabled, .p-tooltip-target-wrapper";

/**
 * Props do `DataTable` para tornar a linha clicável: o clique abre a edição/detalhe
 * do registro. Cliques em botões/ícones da própria linha e seleção de texto são ignorados.
 */
export function clickableRow<T>(onActivate: (row: T) => void) {
  return {
    rowClassName: () => CLICKABLE_ROW_CLASS,
    onRowClick(event: DataTableRowClickEvent) {
      const target = event.originalEvent.target as HTMLElement | null;
      if (target?.closest(INTERACTIVE_SELECTOR)) return;
      if (window.getSelection()?.toString()) return;
      onActivate(event.data as T);
    },
  };
}
